import optionTargetsClient from '@/client/options/definition/option-targets.client';
import {
    baseAtomMapping,
    baseOrganismMapping,
    mergeMappings,
} from '@/options/definition/option-mappings';
import optionTypes from '@/options/definition/option-types';

export default {
    /*
    |-------------------------------------------------------------------------------
    | Atoms
    |-------------------------------------------------------------------------------
    */

    'a-button': mergeMappings(baseAtomMapping, {
        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
            optionTypes.component.boxShadow,
        ],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'a-checkbox': mergeMappings(baseAtomMapping, {
        html: [
            optionTypes.html.inputChecked,
            optionTypes.html.inputName,
            optionTypes.html.inputRequired,
            optionTypes.html.inputValidationMessage,
            optionTypes.html.cookie,
        ],
    }, {
        component: [
            optionTypes.component.border,
            optionTypes.component.addPreset,
        ],
        html: [optionTypes.html.isLink],
    }),

    'a-radio-button': mergeMappings(baseAtomMapping, {
        html: [
            optionTypes.html.inputChecked,
            optionTypes.html.inputName,
            optionTypes.html.inputRequired,
            optionTypes.html.inputValidationMessage,
            optionTypes.html.cookie,
        ],
    }, {
        component: [
            optionTypes.component.border,
            optionTypes.component.addPreset,
        ],
        html: [optionTypes.html.isLink],
    }),

    'a-heading': mergeMappings(baseAtomMapping, {
        component: [optionTypes.component.backgroundColor],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.maxWidth,
            optionTypes.layout.width,
        ],

        text: [
            optionTypes.text.fontFamily,
            optionTypes.text.color,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        html: [optionTypes.html.tag],
    }),

    'a-heading-rich': mergeMappings(baseAtomMapping, {
        component: [optionTypes.component.backgroundColor],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.maxWidth,
            optionTypes.layout.width,
        ],

        text: [
            optionTypes.text.fontFamily,
            optionTypes.text.color,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    },
    { html: [optionTypes.html.isLink] }),

    'a-html': mergeMappings(baseAtomMapping, {}, {
        component: [optionTypes.component.addPreset],
    }),

    'a-icon': mergeMappings(baseAtomMapping, {
        component: [
            optionTypes.component.borderRadius,
            optionTypes.component.boxShadow,
        ],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.width,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontSize,
        ],
    }, {
        component: [optionTypes.component.addPreset],
    }),

    'a-image': mergeMappings(baseAtomMapping, {
        component: [
            optionTypes.component.borderRadius,
            optionTypes.component.boxShadow,
        ],

        image: [
            optionTypes.image.aspectRatio,
            optionTypes.image.imageFilter,
            optionTypes.image.imageGradient,
            optionTypes.image.imageGradientOpacity,
            optionTypes.image.imageSelector,
            optionTypes.image.objectFit,
            optionTypes.image.objectPosition,
            optionTypes.image.zoom,
        ],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],
    }, {
        component: [
            optionTypes.component.padding,
            optionTypes.component.addPreset,
        ],
        html: [optionTypes.html.isLink],
    }),

    'a-input': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.maxWidth,
            optionTypes.layout.width,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        html: [
            optionTypes.html.inputName,
            optionTypes.html.inputRequired,
            optionTypes.html.inputType,
            optionTypes.html.inputValidation,
            optionTypes.html.inputValidationMessage,
            optionTypes.html.inputPlaceholder,
            optionTypes.html.cookie,
            optionTypes.html.cookieLoad,
            optionTypes.html.inputValue,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
        ],
    }, {
        html: [optionTypes.html.isLink],
    }),

    'a-link': mergeMappings(baseAtomMapping, {
        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
            optionTypes.component.boxShadow,
        ],

        layout: [
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }, {
        html: [optionTypes.html.isLink],
    }),

    'a-rich-text': mergeMappings(baseAtomMapping, {
        component: [optionTypes.component.backgroundColor],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        text: [
            optionTypes.text.fontFamily,
            optionTypes.text.color,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    },
    { html: [optionTypes.html.isLink] }),

    'a-select': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        html: [
            optionTypes.html.inputName,
            optionTypes.html.inputRequired,
            optionTypes.html.inputValidationMessage,
            optionTypes.html.inputPlaceholder,
            optionTypes.html.inputOptions,
            optionTypes.html.cookie,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
        ],
    }, {
        html: [optionTypes.html.isLink],
    }),

    'a-textarea': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        html: [
            optionTypes.html.inputName,
            optionTypes.html.inputRequired,
            optionTypes.html.inputValidationMessage,
            optionTypes.html.inputPlaceholder,
            optionTypes.html.cookie,
            optionTypes.html.inputValue,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
        ],
    }, {
        html: [optionTypes.html.isLink],
    }),

    'a-text-multi-line': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.maxCharacters,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'a-text-single-line': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.ellipses,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        html: [
            optionTypes.html.dateFormat,
        ],
    }),

    'a-label': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        accessibility: [
            optionTypes.accessibility.labelFor,
        ],
    }),

    'a-video': mergeMappings(baseAtomMapping, {
        component: [optionTypes.component.boxShadow],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        video: [
            optionTypes.video.aspectRatioVideo,
        ],
    }, {
        component: [optionTypes.component.addPreset],
    }),


    /*
    |-------------------------------------------------------------------------------
    | Organisms
    |-------------------------------------------------------------------------------
    */
    'alert-banner': mergeMappings(baseOrganismMapping, {}),

    carousel: mergeMappings(baseOrganismMapping, {
        carousel: [
            optionTypes.carousel.hideControls,
            optionTypes.carousel.speed,
            optionTypes.carousel.transitionEffect,
        ],

        layout: [
            optionTypes.layout.flexDirection,
        ],
    }),

    'carousel-promo': mergeMappings(baseOrganismMapping, {
        carousel: [optionTypes.carousel.carouselPromoDataSource],
    }),

    'collection-dynamic': mergeMappings(baseOrganismMapping, {
        dynamicCollection: [
            optionTypes.dynamicCollection.dynamicCollection,
            optionTypes.dynamicCollection.dynamicCollectionIncludeLocations,
            optionTypes.dynamicCollection.dynamicCollectionItemGutter,
            optionTypes.dynamicCollection.dynamicCollectionItemWidth,
            optionTypes.dynamicCollection.dynamicCollectionLoader,
        ],

        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
        ],
    }),

    'collection-dynamic-page-range': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        visibility: [
            optionTypes.visibility.opacity,
        ],
    }),

    'collection-dynamic-individual-pages': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
        ],

        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        visibility: [
            optionTypes.visibility.opacity,
        ],
    }),

    'google-map-view': mergeMappings(baseOrganismMapping, {
        googleMap: [
            optionTypes.googleMap.googleMapCoordinates,
        ],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.maxHeight,
            optionTypes.layout.maxWidth,
            optionTypes.layout.width,
        ],
    }),

    'hamburger-button': mergeMappings(baseOrganismMapping, {}),

    'search-keywords': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        search: [optionTypes.search.searchKeywordsFormId],
    }),

    'search-reset-button': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        search: [optionTypes.search.searchKeywordsFormId],
    }),

    'search-stats': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textDecoration,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'collection-item': mergeMappings(baseOrganismMapping, {}),

    'collection-link': mergeMappings(baseOrganismMapping, {}, {
        html: [optionTypes.html.isLink],
    }),

    drawer: mergeMappings(baseOrganismMapping, {}),

    'drawer-collection': mergeMappings(baseOrganismMapping, {
        drawerCollection: [
            optionTypes.drawerCollection.drawerExpand,
            optionTypes.drawerCollection.drawerIconImage,
        ],
    }),

    'drop-zone-multi': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
        ],
    }),

    'drop-zone-single': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
            optionTypes.layout.flexWrap,
            optionTypes.layout.placement,
        ],

        html: [
            optionTypes.html.idOverride,
            optionTypes.html.tag,
        ],
    }),

    'flex-collection': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexWrap,
        ],
    }),

    'flex-container': mergeMappings(baseOrganismMapping, {}),

    'flex-layout': mergeMappings(baseOrganismMapping, {}),

    'flex-placeholder': mergeMappings({}, {
        html: [
            optionTypes.html.idOverride,
            optionTypes.html.tag,
        ],

        accessibility: [
            optionTypes.accessibility.ariaLabel,
            optionTypes.accessibility.ariaLabelledBy,
            optionTypes.accessibility.labelFor,
            optionTypes.accessibility.accessibilityRole,
            optionTypes.accessibility.ariaHidden,
        ],
    }),

    'header-simple': mergeMappings(baseOrganismMapping, {}),

    'icon-search-form': mergeMappings(baseOrganismMapping, {
        search: [
            optionTypes.search.iconSearchCollapse,
            optionTypes.search.iconSearchUrl,
        ],
    }, {
        layout: [
            optionTypes.layout.boxed,
            optionTypes.layout.overflow,
            optionTypes.layout.sticky,
        ],

        component: [
            optionTypes.component.backgroundGradient,
            optionTypes.component.skewY,
        ],

        html: [
            optionTypes.html.isLink,
        ],

        text: [
            optionTypes.text.textAlignment,
        ],

        backgroundImage: [
            optionTypes.backgroundImage.attachment,
            optionTypes.backgroundImage.display,
            optionTypes.backgroundImage.image,
            optionTypes.backgroundImage.size,
            optionTypes.backgroundImage.position,
            optionTypes.backgroundImage.overlay,
            optionTypes.backgroundImage.overlayOpacity,
        ],

        visibility: [
            optionTypes.visibility.opacity,
        ],
    }),

    'link-collection': mergeMappings(baseOrganismMapping, {}, {
        html: [optionTypes.html.isLink],
    }),

    'link-with-icon': mergeMappings(baseOrganismMapping, {
        layout: [optionTypes.layout.placement],
    }),

    'links-nav': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        layout: [optionTypes.layout.flexDirection],
        nav: [optionTypes.nav.navDataSource],
    }, {
        html: [optionTypes.html.isLink],
        layout: [
            optionTypes.layout.placement,
            optionTypes.layout.alignSelf,
        ],
    }),

    'search-facet': mergeMappings(baseOrganismMapping, {
        search: [
            optionTypes.search.searchFacet,
            optionTypes.search.searchFacetValueToggle,
        ],
    }),

    'calendar-facet': mergeMappings(baseOrganismMapping, {
        search: [
            optionTypes.search.searchFacet,
        ],
        calendar: [
            optionTypes.calendar.calendarFacetEventPage,
            optionTypes.calendar.calendarFacetStartDate,
            optionTypes.calendar.calendarFacetTitle,
            optionTypes.calendar.calendarFacetDateHighlight,
            optionTypes.calendar.calendarFacetDateDot,
            optionTypes.calendar.calendarFacetDateBar,
            optionTypes.calendar.calendarFacetWeekdays,
            optionTypes.calendar.calendarFacetDay,
        ],
    }),

    'facet-list-group': mergeMappings(baseAtomMapping, {
        layout: [
            optionTypes.layout.width,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxWidth,
            optionTypes.layout.overflow,
            optionTypes.layout.flexDirection,
        ],

        component: [optionTypes.component.backgroundColor],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'facet-dropdown': mergeMappings(baseAtomMapping, {
        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
        ],
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        layout: [
            optionTypes.layout.width,
            optionTypes.layout.flexDirection,
        ],
    }),

    'nav-dropdown': mergeMappings(baseOrganismMapping, {
        dropdown: [
            optionTypes.dropdown.anchor,
            optionTypes.dropdown.direction,
            optionTypes.dropdown.icon,
            optionTypes.dropdown.iconDisplay,
            optionTypes.dropdown.speed,
            optionTypes.dropdown.trigger,
        ],

        text: [
            optionTypes.text.color,
        ],
    }),

    'nav-dropdown-content': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
        ],
    }),

    'nav-dropdown-collection': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
            optionTypes.layout.placement,
        ],
    }),

    'nav-dropdown-collection-advanced': mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
            optionTypes.layout.placement,
        ],

        hamburgerNav: [
            optionTypes.hamburgerNav.breakpoint,
            optionTypes.hamburgerNav.slideDirection,
            optionTypes.hamburgerNav.slideSpeed,
        ],
    }),

    'o-container': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        backgroundImage: [
            optionTypes.backgroundImage.repeat,
        ],
    }),

    'o-form-container': mergeMappings(baseOrganismMapping, {
        html: [
            optionTypes.html.formEndpoint,
            optionTypes.html.formRequestType,
        ],
    }, {
        html: [optionTypes.html.isLink],
    }),

    'o-layered-container': mergeMappings(baseOrganismMapping, {
        layeredContainer: [
            optionTypes.layeredContainer.layerTransition,
        ],
    }),

    shape: mergeMappings(baseOrganismMapping, {
        layout: [
            optionTypes.layout.placement,
        ],
    }),

    'skip-navigation': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.textAlignment,
        ],
    }, {
        html: [optionTypes.html.isLink],
    }),

    'slide-fancy-v1': mergeMappings(baseOrganismMapping, {}, {
        component: [optionTypes.component.backgroundGradient],
    }),

    'slide-fancy-v2': mergeMappings(baseOrganismMapping, {}, {
        component: [optionTypes.component.backgroundGradient],
    }),

    'slide-fancy-v3': mergeMappings(baseOrganismMapping, {}, {
        component: [optionTypes.component.backgroundGradient],
    }),

    'a-google-map-show-on-map': mergeMappings(baseAtomMapping, {
        component: [
            optionTypes.component.backgroundColor,
            optionTypes.component.borderRadius,
            optionTypes.component.boxShadow,
        ],

        layout: [
            optionTypes.layout.height,
            optionTypes.layout.minHeight,
            optionTypes.layout.minWidth,
            optionTypes.layout.maxHeight,
            optionTypes.layout.maxWidth,
            optionTypes.layout.width,
        ],

        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.textAlignment,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'table-v1': mergeMappings(baseOrganismMapping, {
        component: [optionTypes.component.rowShading],

        text: [optionTypes.text.color],
        table: [optionTypes.table.tableDataSource],
    }, {
        backgroundImage: [
            optionTypes.backgroundImage.image,
            optionTypes.backgroundImage.display,
            optionTypes.backgroundImage.size,
            optionTypes.backgroundImage.position,
            optionTypes.backgroundImage.attachment,
            optionTypes.backgroundImage.overlay,
            optionTypes.backgroundImage.overlayOpacity,
        ],

        component: [optionTypes.component.backgroundGradient],

        html: [optionTypes.html.isLink],
    }),

    'tab-container': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'tab-pane-container': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],
    }),

    'advanced-tabbed-nav': mergeMappings(baseOrganismMapping, {
        text: [
            optionTypes.text.color,
            optionTypes.text.fontFamily,
            optionTypes.text.fontSize,
            optionTypes.text.fontStyle,
            optionTypes.text.fontWeight,
            optionTypes.text.letterSpacing,
            optionTypes.text.lineHeight,
            optionTypes.text.textShadow,
            optionTypes.text.textTransform,
        ],

        layout: [
            optionTypes.layout.contentAlignment,
            optionTypes.layout.flexDirection,
            optionTypes.layout.placement,
        ],

        advancedTabbedNav: [
            optionTypes.advancedTabbedNav.tabDockLocation,
            optionTypes.advancedTabbedNav.advancedTabbedNavTransition,
        ],
    }),

    'tabbed-nav': mergeMappings(baseOrganismMapping, {}),


    /*
    |-------------------------------------------------------------------------------
    | Client options merge
    |-------------------------------------------------------------------------------
    */

    ...optionTargetsClient,
};
